<template>
  <header>
    <div class="header-center auto">
      <!-- <div class="header-left" v-if="typeof back === 'string' || typeof back === 'boolean'">
        <el-button type="text" icon="el-icon-arrow-left" class="back-btn" @click="$router.push(back)"
          v-if="typeof back === 'string'">返回</el-button>
        <el-button type="text" icon="el-icon-arrow-left" class="back-btn" @click="$router.go(-1)" v-else>返回</el-button>
      </div> -->
      <div class="header-left">
        <span class="logo">
          <img src="@/assets/images/global/logo-index.png" alt="" />
        </span>
        <!-- <span class="logo-text"></span>
        <nav>
          <router-link :class="{ 'is-index': isIndex }" to="/">首页</router-link>
        </nav> -->
      </div>
      <el-menu :default-active="activeIndex" mode="horizontal" background-color="#2C2F39" text-color="#fff"
        active-text-color="#fff" router>
        <el-menu-item index="Home" :route="{ path: '/' }">首页</el-menu-item>
        <el-menu-item index="ContractList" :route="{ path: '/space/contract-list?status=all' }">合同管理</el-menu-item>
        <el-menu-item index="Info" :route="{ path: '/user/info' }">个人中心</el-menu-item>
      </el-menu>
      <div class="header-right">
        <el-popover v-model="capPopShow" placement="bottom" title="" width="320" trigger="click" content=""
          popper-class="cap-pop" :visible-arrow="false">
          <div class="space-item" :class="{ 'is-check': item.checked }" v-for="(item, idx) in spaceInfoList" :key="idx"
            @click="handleSelectSpace(idx)">
            <span class="sup">{{ computeSpaceItemName(item) }}</span>
            <div class="item-right">
              <div class="item-right-inner">
                <svg-icon iconClass="auth-success" class="icon-auth" v-if="item.spaceStatus == 'passAuth'"></svg-icon>
                <!-- <img src="@/assets/images/global/auth-success.png" alt="" class="icon-auth"
                  v-if="item.spaceStatus == 'passAuth'"> -->
                <svg-icon iconClass="auth-fail" class="icon-auth"
                  v-if="item.spaceStatus == 'rejectPersonAuth' || item.spaceStatus == 'rejectCompanyAuth'"></svg-icon>
                <!-- <img src="@/assets/images/global/auth-fail.png" alt="" class="icon-auth"
                  > -->
                <span class="sub" v-if="item.spaceStatus == 'passAuth'">已认证</span>
                <span class="sub"
                  v-if="item.spaceStatus == 'inPersonAuth' || item.spaceStatus == 'inCompanyAuth'">认证中</span>
                <span class="sub"
                  v-if="item.spaceStatus == 'rejectPersonAuth' || item.spaceStatus == 'rejectCompanyAuth'">认证失败</span>
                <span class="sub" v-if="item.spaceStatus == 'notAuth'">未认证</span>
              </div>
              <svg-icon icon-class="check" class="icon-check" v-if="item.checked"></svg-icon>
            </div>
          </div>
          <div class="capsule-container" slot="reference" :class="{ 'is-active': capPopShow }">
            <div class="inner">
              <div class="inner-left">{{ computeSpaceName() }}</div>
              <div class="inner-right">
                <svg-icon iconClass="auth-success" class="icon-auth"
                  v-if="currentSpace.space && currentSpace.space.spaceStatus == 'passAuth'"></svg-icon>
                <svg-icon iconClass="auth-fail" class="icon-auth"
                  v-if="currentSpace.space && (currentSpace.space.spaceStatus == 'rejectPersonAuth' || currentSpace.space.spaceStatus == 'rejectCompanyAuth')"></svg-icon>
                <!-- <img src="@/assets/images/global/auth-success.png" alt=""
                  v-if="currentSpace.space && currentSpace.space.spaceStatus == 'passAuth'">
                <img src="@/assets/images/global/auth-fail.png" alt=""
                  v-if="currentSpace.space && (currentSpace.space.spaceStatus == 'rejectPersonAuth' || currentSpace.space.spaceStatus == 'rejectCompanyAuth')"> -->
                <span v-if="currentSpace.space && currentSpace.space.spaceStatus == 'passAuth'">已认证</span>
                <span
                  v-if="currentSpace.space && (currentSpace.space.spaceStatus == 'inPersonAuth' || currentSpace.space.spaceStatus == 'inCompanyAuth')">认证中</span>
                <span
                  v-if="currentSpace.space && (currentSpace.space.spaceStatus == 'rejectPersonAuth' || currentSpace.space.spaceStatus == 'rejectCompanyAuth')">认证失败</span>
                <span v-if="currentSpace.space && currentSpace.space.spaceStatus == 'notAuth'">未认证</span>
                <i class="el-icon-caret-bottom" v-if="spaceInfoList.length > 1"></i>
              </div>
            </div>
          </div>
        </el-popover>

        <el-popover placement="bottom" title="" width="238" trigger="hover" content="" popper-class="service-pop"
          :visible-arrow="false">
          <div class="service">
            <svg-icon iconClass="service-fill" class="icon-service"></svg-icon>客服电话
          </div>
          <div class="tel">
            0431-85177688
          </div>
          <div class="workday">
            工作时间：周一至周五 9:00-18:00
          </div>
          <svg-icon slot="reference" iconClass="service" class="icon-service"></svg-icon>
        </el-popover>
        <el-popover placement="bottom" title="" width="245" trigger="click" content="" popper-class="user-pop"
          :visible-arrow="false">
          <div class="avatar">
            <svg-icon :iconClass="userInfo.userType && userInfo.userType == 'company' ? 'company' : 'person'"
              class="icon-user"></svg-icon>
            <!-- <img
              :src="userInfo.userType == 'company' ? require('@/assets/images/home/space-company.png') : require('@/assets/images/global/user@2x.png')"
              alt="" class="icon-user"> -->
            <div class="avatar-right">
              <div class="username">{{ userInfo.nickName }}</div>
              <div class="user-auth-tag" v-if="userInfo.isAuthed == 'passAuth'"><img
                  src="@/assets/images/global/auth-success.png" alt="">已认证</div>
              <div class="user-auth-tag" v-if="userInfo.isAuthed == 'notAuth'">未认证</div>
              <div class="user-auth-tag"
                v-if="userInfo.isAuthed == 'rejectPersonAuth' || userInfo.isAuthed == 'rejectCompanyAuth'"><img
                  src="@/assets/images/global/auth-fail.png" alt="">认证失败</div>
              <div class="user-auth-tag"
                v-if="userInfo.isAuthed == 'inPersonAuth' || userInfo.isAuthed == 'inCompanyAuth'">认证中</div>
            </div>

          </div>
          <div class="center" @click="handleCommand('user')">
            <svg-icon iconClass="center"></svg-icon>
            个人中心
          </div>
          <div class="logout" @click="handleCommand('logout')">
            <svg-icon iconClass="logout"></svg-icon>
            退出登录
          </div>
          <svg-icon slot="reference"
            :iconClass="userInfo.userType && userInfo.userType == 'company' ? 'company' : 'person'"
            class="icon-user"></svg-icon>
          <!-- <img slot="reference"
            :src="userInfo.userType == 'company' ? require('@/assets/images/home/space-company.png') : require('@/assets/images/global/user@2x.png')"
            alt="" class="icon-user"> -->
        </el-popover>

      </div>
    </div>
  </header>
</template>

<script>
import { mapState } from "vuex";
import {
  getUserAccountInfo,
  getUserSpaceInfo,
  setTenantIdApi
} from "@/api/global";
import { userInfo } from "os";
export default {
  data() {
    return {
      activeIndex: "Home",
      capPopShow: false
    }
  },
  props: {
    back: {
      Boolean,
      String,
    },
  },
  computed: {
    isIndex() {
      return this.$route.path == "/";
    },
    ...mapState([
      "spaceInfoList",
      "userInfo",
      // "userContractInfo",
      // "companyList",
      "currentSpace",
    ]),
  },
  watch: {
    $route: {
      handler(to, from) {
        this.getCurrentMenu(to.name);
      },
      immediate: true
    }
  },
  // mounted() {
  //   // this.spaceName = (this.$store.state.currentSpace && this.$store.state.currentSpace.space && this.$store.state.currentSpace.space.spaceName) ? this.$store.state.currentSpace.space.spaceName : this.$store.state.spaceInfoList[0].spaceName
  //   //this.spaceName = (this.$store.state.currentSpace && this.$store.state.currentSpace.space && this.$store.state.currentSpace.space.spaceName) ? this.$store.state.currentSpace.space.spaceName : this.$store.state.spaceInfoList[0].spaceName
  // },
  created() {
    if (!this.spaceInfoList.length) {

      this.initGetUserSpaceInfo();
    }
  },
  methods: {
    initGetUserSpaceInfo() {
      getUserSpaceInfo().then((res) => {
        if (res.code !== 200) {
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        } else {
          res.data.spaceInfoArray.map((_item, _idx) => {
            if (_idx == 0) {
              _item.checked = true;
            } else {
              _item.checked = false;
            }
          })
          this.handleSetTenantId(res.data.spaceInfoArray[0].tenantId, res.data.spaceInfoArray[0]);
          this.$store.commit("SET_SPACE_INFO_LIST", res.data.spaceInfoArray);
        }
      });
    },
    handleSetTenantId(tenantId, space) {
      return new Promise((resolve, reject) => {
        setTenantIdApi({ tenantId }).then((res) => {
          if (res.code != 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
            reject();
          } else {
            resolve();
            this.$store.commit("SET_CURRENT_SPACE", { tenantId, space });
          }
        });
      })

    },

    getCurrentMenu(name) {
      const contractListNavArray = ["ContractList", "approveList"];
      const userInfoNavArray = ["Info", "CompanyInfo", "contact", "bill", "Config", "settings", "seal"];
      if (userInfoNavArray.includes(this.$route.name)) {
        this.activeIndex = 'Info';
      } else if (contractListNavArray.includes(this.$route.name)) {
        this.activeIndex = 'ContractList';
      } else {
        this.activeIndex = name;
      }
    },
    computeSpaceName() {
      if (!this.currentSpace.space) {
        return ""
      }
      if (this.currentSpace.space.spaceStatus == 'notAuth') {
        return this.currentSpace.space.spaceType == 'person' ? '个人' : '企业';
      } else {
        return this.currentSpace.space.spaceName ? this.currentSpace.space.spaceName : '';
      }
    },
    computeSpaceItemName(space) {
      if (space.spaceStatus == 'notAuth') {
        return space.spaceType == 'person' ? '个人' : '企业';
      } else {
        return space.spaceName ? space.spaceName : '';
      }
    },
    async handleSelectSpace(_idx) {
      let spaces = this.spaceInfoList;
      spaces.forEach(element => {
        element.checked = false;
      });
      spaces[_idx].checked = true;
      this.$store.commit("SET_SPACE_INFO_LIST", spaces);
      await this.handleSetTenantId(spaces[_idx].tenantId, spaces[_idx]);
      this.$bus.$emit("emitSpaceChange");
      this.capPopShow = false;
      this.$route.name !== "Home" && this.$router.push("/")
    },
    handleCommand(command) {
      if (command == "user") {
        this.$router.push({
          path: "/user/info",
        });
      } else if (command == "logout") {
        this.$confirm("确定退出系统吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.logout();
        });
      }
    },
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    },

  },
};
</script>
<style lang="scss">
.el-popover.cap-pop {
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.16);
  border-radius: 6px;
  padding: 20px 0;

  .space-item {
    padding: 14px 27px 14px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    &.is-check {
      background: #ECF2FE;
    }

    .item-right {
      width: 96px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .item-right-inner {
        display: flex;
        align-items: center;
        justify-content: flex-start;
      }
    }

    .sup {
      font-size: 18px;
      font-weight: 400;
      color: #313843;
      width: 162px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .sub {
      font-size: 14px;
      font-weight: 400;
      color: #86909C;
    }

    .icon-auth {
      width: 12px;
      height: 12px;
      margin-right: 4px;
      // margin-top: 1px;
    }

    .icon-check {
      width: 16px;
      height: 16px;
      // margin-left: 22px;
    }
  }
}

.el-popover.service-pop {
  width: 238px;
  height: 126px;
  padding: 20px;
  background: #FFFFFF;
  box-shadow: 4px 4px 10px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px 10px 10px 10px;

  .service {
    font-size: 18px;
    font-weight: 500;
    color: #1D2129;
    line-height: 22px;
    display: flex;
    align-items: center;

    .svg-icon {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
  }

  .tel {
    font-size: 14px;
    font-weight: 400;
    color: #1D2129;
    line-height: 20px;
    margin-top: 12px;
  }

  .workday {
    font-size: 12px;
    font-weight: 400;
    color: #86909C;
    margin-top: 12px;
  }
}

.el-popover.user-pop {
  width: 245px;
  // height: 222px;
  background: #FFFFFF;
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.16);
  border-radius: 6px 6px 6px 6px;
  padding: 0;

  .avatar {
    padding: 20px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #F2F3F5;

    .icon-user {
      width: 50px;
      height: 50px;
      margin-right: 12px;
    }

    .avatar-right {
      display: flex;
      flex-direction: column;

      .username {
        font-size: 18px;
        font-weight: 500;
        color: #313843;
        margin-top: -2px;
      }

      .user-auth-tag {
        font-size: 14px;
        font-weight: 400;
        color: #86909C;
        margin-top: 5px;
        display: flex;
        align-items: center;

        img {
          width: 12px;
          margin-right: 5px;
        }
      }
    }
  }

  .center {
    padding: 20px 30px;
    border-bottom: 1px solid #F2F3F5;
    font-size: 18px;
    font-weight: 400;
    color: #1D2129;
    display: flex;
    align-items: center;
    cursor: pointer;

    &:hover {
      background: #F2F3F5;
    }

    .svg-icon {
      width: 26px;
      height: 26px;
      margin-right: 16px;
    }
  }

  .logout {
    padding: 20px 30px;
    border-bottom: 1px solid #F2F3F5;
    font-size: 18px;
    font-weight: 400;
    color: #1D2129;
    display: flex;
    align-items: center;
    cursor: pointer;

    &:hover {
      background: #F2F3F5;
    }

    .svg-icon {
      width: 26px;
      height: 26px;
      margin-right: 16px;
    }
  }
}

.el-dropdown-menu__item {
  text-align: center;
}

.el-dropdown-menu__item:not(.is-disabled):hover,
.el-dropdown-menu__item:focus {
  background-color: rgba(46, 174, 253, 0.1) !important;
  color: #2eaefd !important;
}
</style>
<style lang="scss" scoped>
header {
  width: 100%;
  height: 60px;
  background: #2C2F39;
  overflow: hidden;

  .logo {
    text-align: center;

    img {
      width: 242px;
      height: auto;
    }
  }

  .el-menu {
    border-bottom: none;

    .el-menu-item {
      height: 60px;
      line-height: 60px;
      font-size: 20px;
      font-weight: 500;
      padding: 0;
      margin: 0 25px;
      opacity: .7;
      background-color: #2C2F39 !important;

      &:hover {
        opacity: 1;
      }

      &.is-active {
        border-bottom-width: 5px;
        opacity: 1;
      }
    }
  }

  .header-center {
    display: flex;
    line-height: 60px;
    justify-content: space-between;
    height: 60px;
    padding: 0 20px 0 8px;
    overflow: hidden;

    .header-left {
      display: flex;

      .logo-text {
        margin-left: 16px;
        font-size: 20px;
        color: #ffffff;
      }

      .back-btn {
        color: #fff;
        font-size: 18px;
      }
    }

    .header-right {
      display: flex;
      align-items: center;
      justify-content: space-between;

      /deep/ .el-popover__reference-wrapper {
        display: block;
        align-items: center;
        display: flex;
      }

      .capsule-container {
        width: 229px;
        height: 38px;
        background: rgba(247, 248, 250, 0.2);
        border-radius: 19px;
        opacity: 1;
        padding: 0 20px;
        font-size: 18px;
        font-weight: 400;
        color: #FFFFFF;
        border: 1px solid transparent;
        cursor: pointer;

        &:hover {
          border-color: #FFFFFF;
        }

        &.is-active {
          border-color: #FFFFFF;
          opacity: .5;
        }


        .inner {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .inner-left {
            width: 105px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .inner-right {
            font-size: 14px;
            font-weight: 400;
            color: #FFFFFF;
            display: flex;
            align-items: center;
            white-space: nowrap;

            .svg-icon {
              width: 12px;
              height: 14px;
              margin-right: 4px;
            }

            /deep/ .el-icon-caret-bottom {
              margin-left: 2px;
            }
          }
        }
      }

      .icon-service {
        width: 30px;
        height: 30px;
        margin-right: 24px;
        margin-left: 32px;
      }

      .icon-user {
        width: 30px;
        height: 30px;
        cursor: pointer;
      }
    }
  }
}
</style>
